/*
 * Copyright 2017-present Evernote Corporation. All rights reserved.
 */

import Structures from 'ion-structures';

// FIXME: Do we still need to save messages? Is it safe to change this value to 1?
const MAX_PERSISTED_MESSAGES_IN_QUEUE = 10;

class MessageQueue<Message> extends Structures.Queue<Message> {
  /**
   * Special method to add messages to the queue that keeps the length of the
   * message queue under control
   * @param {Message} message
   */
  add(message: Message) {
    if (this.length >= MAX_PERSISTED_MESSAGES_IN_QUEUE) {
      this.dequeue();
    }

    this.enqueue(message);
  }

  /**
   * Clear the entire queue.
   */
  clearMessages() {
    this.clear();
  }
}

export default MessageQueue;
